<div class="flex flex-col gap-2">
  <div class="relative">
    <l-icon class="pointer-events-none absolute left-4 top-1/2 z-10 -translate-y-1/2 text-xl text-lGray600">image</l-icon>
    <input
      [id]="urlInputId"
      type="url"
      lInput
      [ngModel]="imageUrl"
      (ngModelChange)="onImageUrlChange($event)"
      [ngModelOptions]="{ standalone: true }"
      [placeholder]="urlPlaceholder"
      maxlength="500"
      class="border-none pl-11 rounded-xl"
    />
  </div>

  @if (recommendation) {
    <p class="text-xs text-lGray600">
      {{ recommendation }}
    </p>
  }

  @if (showUrlPreviewError) {
    <p class="text-xs text-lDanger">
      Não foi possível carregar a imagem. Use uma URL direta do arquivo (ex: .jpg, .png ou .webp).
    </p>
  }

  <div class="flex flex-wrap items-center gap-3">
    <input
      [id]="fileInputId"
      type="file"
      [accept]="accept"
      class="hidden"
      (change)="onImageFileSelected($event)"
    />
    <label
      [for]="fileInputId"
      class="group flex h-12 w-full cursor-pointer items-center justify-center gap-2 rounded-xl border border-lGray600/70 bg-transparent px-4 text-sm font-semibold text-lGray100 backdrop-blur-sm transition-all duration-200 hover:border-lPrimary hover:text-lWhite"
    >
      <l-icon class="text-lg text-lGray500 transition-colors group-hover:text-lPrimary">upload</l-icon>
      {{ uploadLabel }}
    </label>
  </div>

  @if (hasImagePreview) {
    <div class="flex w-full justify-center">
      <div class="relative w-fit max-w-full">
        <img
          [src]="previewImageSrc"
          [alt]="previewAlt"
          class="max-h-40 w-auto max-w-full rounded-xl object-contain"
        />
        <button
          type="button"
          class="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-black/70 text-white transition-colors hover:bg-lDanger"
          aria-label="Remover imagem"
          (click)="clearCover()"
        >
          ×
        </button>
      </div>
    </div>
  } @else {
    <div class="flex justify-center">
      <img
        src="assets/images/image-placeholder.svg"
        [alt]="placeholderAlt"
        class="h-44 w-auto object-contain"
      />
    </div>
  }

  @if (imageFileName) {
    <div class="flex justify-center">
      <span class="max-w-full truncate px-3 py-1 text-xs text-lGray500">
        {{ imageFileName }}
      </span>
    </div>
  }
</div>
